import { resetWidget } from '../../../actions/common';
import { selectTransactionId } from '../../../selectors/checkout';
import { selectActivePaymentMethod } from '../../../selectors/paymentMethods';
import { TWidgetResult } from '../../../types/api';
import { TThunkAction } from '../../../types/redux';
import { EPaymentProvider } from '../../../types/redux/paymentMethods';
import { getResultSuccess, getResultFail, getResultCancel } from '../../../utils/result';
import { getYooMoneyPaymentType } from './utils';

interface IParams {
  token: string;
}

export const openYooKassaWidgetThunk =
  (params: IParams): TThunkAction =>
  async (dispatch, getState, context) => {
    const { token } = params;

    const { telemetry, logger, resolveWidgetResult } = context;

    const state = getState();
    const { type } = selectActivePaymentMethod(state);
    const transactionId = selectTransactionId(state);

    const paymentMethod = getYooMoneyPaymentType(type);

    telemetry.increment('yoo-kassa-widget.init');

    const widget = new window.YooMoneyCheckoutWidget({
      confirmation_token: token,
      customization: {
        modal: true,
        payment_methods: [paymentMethod],
      },
      error_callback({ error }) {
        logger.error(error, {
          description: 'Ошибка открытия модалки оплаты ЮKassa',
        });

        telemetry.increment('yoo-kassa-widget.fail');
      },
    });

    await widget.render();

    const result = await new Promise((resolve: (value: TWidgetResult) => void) => {
      widget.on('success', () => {
        widget.destroy();

        resolve(
          getResultSuccess({
            // Токен выглядит примерно так: ct-24301ae5-000f-5000-9000-13f5f1c2f8e0
            // Для проверки статуса платежа наша ручка принимает токен без префикса ct-.
            // Удаляем его.
            paymentId: token.substring(3),
            provider: EPaymentProvider.YooKassa,
            transactionId,
          }),
        );
      });
      widget.on('fail', () => {
        widget.destroy();

        resolve(getResultFail());
      });
      widget.on('modal_close', () => {
        widget.destroy();

        resolve(getResultCancel());
      });
    });

    dispatch(resetWidget());

    resolveWidgetResult(result);
  };
